module.exports = __webpack_public_path__ + "static/media/rebalance_date.f10ab469.svg";